'use client';

import MyTabGroup from '@/components/my/common/group/TabGroup';
import useGlobalUIStore from '@/stores';
import useMyStore from '@/stores/my';
import {useFavoriteGroupTabs} from './hooks/useFavoriteGroupTabs';

const MyFavoriteTabGroup = () => {
  const {getFavoriteGroups, favoriteGroups} = useMyStore();
  const {setRefreshTimestamp} = useGlobalUIStore();

  const {
    favoriteGroupTabs,
    handleGroupTabChanged,
    handleGroupAdd,
    handleGroupEdit,
  } = useFavoriteGroupTabs(
    getFavoriteGroups,
    favoriteGroups,
    setRefreshTimestamp,
  );

  return (
    <MyTabGroup
      tabs={favoriteGroupTabs}
      type='flat'
      onHandle={handleGroupTabChanged}
      moreTab={
        <>
          <button type='button' className='add' onClick={handleGroupAdd}>
            그룹 추가
          </button>
          <button type='button' className='edit' onClick={handleGroupEdit}>
            <span>그룹 편집</span>
          </button>
        </>
      }
    />
  );
};

export default MyFavoriteTabGroup;
